import React, { useState, useRef } from 'react';
import { API } from '../../config';
import axios from 'axios';
import { IconSpinner, IconChart } from '../Icons';

export default function StepUpload({ onUploaded }) {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef();

  const ACCEPTED = ['.xlsx', '.xlsm', '.csv'];

  function isValidFile(file) {
    return ACCEPTED.some(ext => file.name.toLowerCase().endsWith(ext));
  }

  async function handleFile(file) {
    if (!file) return;
    if (!isValidFile(file)) {
      setError('Formato non supportato. Usa .xlsx, .xlsm o .csv');
      return;
    }
    setError(null);
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(`${API}/import/upload`, fd);
      onUploaded(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Errore durante il caricamento');
    } finally {
      setUploading(false);
    }
  }

  function onDrop(e) {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    handleFile(file);
  }

  function onDragOver(e) {
    e.preventDefault();
    setDragging(true);
  }

  function onDragLeave() {
    setDragging(false);
  }

  function onInputChange(e) {
    handleFile(e.target.files[0]);
  }

  return (
    <div className="card">
      <h2>Carica File</h2>
      <div
        className={`dropzone${dragging ? ' dragging' : ''}`}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onClick={() => !uploading && inputRef.current.click()}
        style={{ cursor: uploading ? 'default' : 'pointer' }}
      >
        <input
          ref={inputRef}
          type="file"
          accept=".xlsx,.xlsm,.csv"
          style={{ display: 'none' }}
          onChange={onInputChange}
        />
        {uploading ? (
          <div>
            <IconSpinner size={32} />
            <p style={{ marginTop: 12, color: '#64748b' }}>Caricamento in corso…</p>
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'center' }}><IconChart size={40} /></div>
            <p style={{ margin: '0 0 4px', fontWeight: 600, color: '#0f172a' }}>
              Trascina qui il file o clicca per selezionarlo
            </p>
            <p style={{ margin: 0, fontSize: 12, color: '#94a3b8' }}>
              Formati supportati: .xlsx, .xlsm, .csv
            </p>
          </div>
        )}
      </div>
      {error && (
        <div style={{
          marginTop: 12, padding: '10px 14px',
          background: '#fef2f2', border: '1px solid #fca5a5',
          borderRadius: 8, color: '#b91c1c', fontSize: 13
        }}>
          {error}
        </div>
      )}
    </div>
  );
}
